import { render, staticRenderFns } from "./Sso2.vue?vue&type=template&id=7a49bb15&"
import script from "./Sso2.vue?vue&type=script&lang=js&"
export * from "./Sso2.vue?vue&type=script&lang=js&"
import style0 from "./Sso2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports